import MainLayout from "../../layout/main/main";
import {Navigate, Route, Routes, useLocation} from "react-router-dom";
import CommunityIndex from "./Community";
import PricingIndex from "./Pricing";
import PracticeIndex from "./practice";
import SettingIndex from "./Setting";
import HelpIndex from "./Help";
import ToolsIndex from "./Tools";
import {useSession} from "../../redux/Reducers/AuthReducer";
import AuthEntry from "../auth/authEntry";
import Guide from "./Guide";
import PageNotFound from "./404";
import NotificationPage from "./notification/notifications";
import BuyMembershipModal from "../../Modals/buy-memebership-modal/buy-membership-modal";
import PaymentSuccess from "./payment-success/payment-success";
import MaterialIndex from "./Tools/Material";

export default function MainEnter({className, ...props}) {
    const {authActions} = useSession();
    let location = window.location.pathname;
    if (window.location.search) {
        location = location + window.location.search
    }
    if (!authActions.isUserAuthenticated())
        return (
            <div className={`max-w-[100vw]  ${className}`}>
                <Routes>
                    <Route path="/auth/*" element={<AuthEntry/>}/>
                    <Route path="/*"
                           element={<Navigate to={"/auth/login" + "?next=" + location} replace/>}/>
                </Routes>
            </div>
        )
    return (
        <MainLayout className={` ${className}`}>
            <BuyMembershipModal/>
            <Routes>
                <Route path="/community" element={<CommunityIndex/>}/>
                <Route path="/pricing/*" element={<PricingIndex/>}/>
                <Route path="/practice/*" element={<PracticeIndex/>}/>
                <Route path="/settings/*" element={<SettingIndex/>}/>
                <Route path="/payment-success" element={<PaymentSuccess/>}/>
                <Route path="/tools/*" element={<ToolsIndex/>}/>
                <Route path="/material" element={<MaterialIndex/>}/>
                <Route path="/guide/:title" element={<Guide/>}/>
                <Route path="/help/*" element={<HelpIndex/>}/>
                <Route path="/notifications/*" element={<NotificationPage/>}/>
                <Route path="/404" element={<PageNotFound/>}/>
            </Routes>
        </MainLayout>

    )
}